<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="师傅订单ID">
                <a-input v-model="queryParam.masterOrderId" placeholder="师傅订单ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="雇主订单ID">
                <a-input v-model="queryParam.customerOrderId" placeholder="雇主订单ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="师傅用户ID">
                <a-input v-model="queryParam.masterUserId" placeholder="师傅用户ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付状态">
                <a-input v-model="queryParam.payStatus" placeholder="0-3" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="结算状态">
                <a-input v-model="queryParam.settleStatus" placeholder="0-5" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:masterBond:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:masterBond:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:masterBond:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['order:masterBond:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:masterBond:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delOrderMasterBond, pageOrderMasterBond } from '@/api/order/masterBond'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'OrderMasterBond',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      total: 0,
      single: true,
      multiple: true,
      ids: [],
      queryParam: {
        masterOrderId: undefined,
        customerOrderId: undefined,
        masterUserId: undefined,
        payStatus: undefined,
        settleStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: 'id', dataIndex: 'id', ellipsis: true, align: 'center', width: 100 },
        { title: '师傅订单ID', dataIndex: 'masterOrderId', ellipsis: true, align: 'center', width: 120 },
        { title: '雇主订单ID', dataIndex: 'customerOrderId', ellipsis: true, align: 'center', width: 120 },
        { title: '师傅用户ID', dataIndex: 'masterUserId', ellipsis: true, align: 'center', width: 120 },
        { title: '支付状态', dataIndex: 'payStatus', align: 'center', width: 90 },
        { title: '结算状态', dataIndex: 'settleStatus', align: 'center', width: 90 },
        { title: '应付', dataIndex: 'payableAmount', align: 'center', width: 100 },
        { title: '已付', dataIndex: 'paidAmount', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 140, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const q = { ...this.queryParam }
      ;['masterOrderId', 'customerOrderId', 'masterUserId', 'payStatus', 'settleStatus'].forEach(k => {
        if (q[k] === '' || q[k] === undefined) {
          delete q[k]
        } else if (['masterOrderId', 'customerOrderId', 'masterUserId', 'payStatus', 'settleStatus'].includes(k)) {
          q[k] = Number(q[k])
          if (Number.isNaN(q[k])) delete q[k]
        }
      })
      pageOrderMasterBond(q).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        masterOrderId: undefined,
        customerOrderId: undefined,
        masterUserId: undefined,
        payStatus: undefined,
        settleStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      const that = this
      const ids = row.id != null ? [row.id] : this.ids
      if (row.id != null) {
        this.ids = [row.id]
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delOrderMasterBond(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          that.ids = that.selectedRows.map(item => item.id)
        }
      })
    }
  }
}
</script>
